'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearCurrentChannel = undefined;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var clearCurrentChannel = exports.clearCurrentChannel = (0, _reduxActions.createAction)(ActionTypes.CLEAR_CURRENT_CHANNEL);


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConversationsActions/clearCurrentChannel.js
// module id = 1036
// module chunks = 2 3